import styled from 'styled-components'

export const Wrapper = styled.div`
	// background-image: url('../illustrations/details.svg');
	// background-size: contain;
	// background-position: left top;
	// background-repeat: no-repeat;
`

export const SocialWrapper = styled.div`
	padding: 4rem 0;
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media (max-width: 960px) {
		flex-direction: column;
	}
`
export const Links = styled.div`
	display: flex;
	align-items: center;

	a {
		margin: 0 1.5rem;

		img {
			margin: 0;
			&:hover {
				opacity: 1;
				transform: rotate(-360deg);
				transition: transform 0.8s ease-in-out;
			}
		}

		&:first-child {
			margin: 0;
			margin-right: 1.5rem;
		}

		&:last-child {
			margin: 0;
			margin-left: 1.5rem;
		}
	}
`

export const Details = styled.div`
	flex: 1;
	padding-left: 2rem;

	@media (max-width: 960px) {
		padding-left: unset;
		width: 100%;
	}

	h1 {
		margin-bottom: 2rem;
		font-size: 26pt;
		color: #212121;
	}

	p {
		margin-bottom: 2.5rem;
		font-size: 18pt;
		font-weight: normal;
		line-height: 1.3;
		color: #707070;
	}
`

export const Thumbnail = styled.div`
	flex: 1;

	@media (max-width: 960px) {
		width: 100%;
		margin-bottom: 2rem;
	}

	img {
		width: 100%;
	}
`
